import React, { useRef } from 'react';

import { cn } from '@lyearn/style';

import BaseVirtualizedList, { VirtuosoHandle } from './BaseList';
import type { ComputeItemKey, ItemContent, VirtualizedListProps } from './types';

// NOTE: for most of the use cases use `VirtualizedList`, but for more complex cases please use `BaseVirtualizedList`
const VirtualizedList = React.forwardRef<VirtuosoHandle, VirtualizedListProps>((props, ref) => {
  const { style, Header, ListFooterComponent, customScrollParent, ...otherProps } = props;

  const componentsRef = useRef<any>({});

  componentsRef.current.Header = React.useCallback(() => (Header ? Header : null), [Header]);
  componentsRef.current.Footer = React.useCallback(
    () => (ListFooterComponent ? ListFooterComponent : null),
    [ListFooterComponent],
  );

  return (
    <BaseVirtualizedList
      ref={ref}
      {...otherProps}
      className={cn(otherProps.className, otherProps.contentContainerClassName)}
      components={componentsRef.current}
      style={style as any}
    />
  );
});

export default VirtualizedList;

export type { ComputeItemKey, ItemContent };
